import { render, staticRenderFns } from "./AddLogoDialog.vue?vue&type=template&id=65b61274&scoped=true&"
import script from "./AddLogoDialog.vue?vue&type=script&lang=js&"
export * from "./AddLogoDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddLogoDialog.vue?vue&type=style&index=0&id=65b61274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b61274",
  null
  
)

export default component.exports